
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/firms/ej",
      function () {
        return require("private-next-pages/firms/ej.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/firms/ej"])
      });
    }
  